import * as React from 'react';
import Helmet from 'react-helmet';
import { WithStyles, withStyles, createStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

import SvgIcon from 'ha/components/SvgIcon';
import units from 'ha/theme/units';
import { withIntl, IntlProps } from 'ha/i18n';
import Row from 'ha/ui/next/Row';
import Col from 'ha/ui/next/Col';
import Text from 'ha/ui/next/Text';
import SearchAlertDesktop from '../containers/SearchAlerts/SearchAlertDesktop';

const styles = createStyles({
  wrapper: {
    margin: units.rem(1.5),
    flexGrow: 2,
  },
  root: {
    padding: units.rem(1),
  },
  sadIcon: {
    marginTop: units.rem(1),
    height: units.rem(5),
  },
});

export const SearchResultsEmpty: React.SFC<
  IntlProps & WithStyles<typeof styles>
> = ({ intl: { T }, classes }) => (
  <div className={classes.wrapper}>
    <Row spacing={32}>
      <Col xs={12}>
        <Paper
          classes={{
            root: classes.root,
          }}
        >
          <Helmet meta={[{ name: 'robots', content: 'noindex' }]} />
          <Row spacing={24}>
            <Col>
              <Text variant="title" fw="bold">
                {T('search_empty_title')}
              </Text>
            </Col>
          </Row>
          <Row spacing={24}>
            <Col>{T('search_empty_text_search_alert')}</Col>
          </Row>
          <Row spacing={24}>
            <Col>
              <SearchAlertDesktop />
            </Col>
          </Row>
        </Paper>
      </Col>
    </Row>
    <Row alignItems="center" justify="center" spacing={32}>
      <Col>
        <SvgIcon name="sad-inbox" className={classes.sadIcon} />
      </Col>
    </Row>
  </div>
);

export default withStyles(styles)(withIntl(SearchResultsEmpty));
